"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonWizard = void 0;
const React = require("react");
const bronson_react_1 = require("@vwfs-bronson/bronson-react");
const wizard_item_1 = require("./wizard-item");
const constants_1 = require("../../utils/constants");
const wizard_type_1 = require("./wizard.type");
const BronsonWizard = (props) => {
    var _a;
    return (React.createElement(bronson_react_1.Wizard, { noInteraction: props.noInteraction, collapseBreakpoint: props.collapseAtBreakpoint, collapsedTitle: 'Show Wizard', open: false, collapsedText: (_a = props.triggerText) !== null && _a !== void 0 ? _a : 'Current Step', collapsedCounter: `${props.currentStep + constants_1.one}/${props.steps}` }, [...Array(props.steps).keys()].map((index) => {
        var _a;
        const title = (_a = props.stepTitles[index]) !== null && _a !== void 0 ? _a : '';
        let type = wizard_type_1.BronsonWizardItemTypes.DONE;
        if (index === props.currentStep) {
            type = props.currentError
                ? wizard_type_1.BronsonWizardItemTypes.ERROR
                : wizard_type_1.BronsonWizardItemTypes.ACTIVE;
        }
        else if (index < props.currentStep) {
            type = wizard_type_1.BronsonWizardItemTypes.DONE;
        }
        return (React.createElement(wizard_item_1.BronsonWizardItem, Object.assign({ key: index, title: title }, (type ? { type } : {}), (props.onChange
            ? {
                onClick: () => props.onChange && props.onChange(index),
            }
            : {}))));
    })));
};
exports.BronsonWizard = BronsonWizard;
